import { jsx as o, jsxs as i } from "react/jsx-runtime";
import { useRef as s, useEffect as p } from "react";
import { ArrowIcon as g } from "../../assets/svgs/ArrowIcon.js";
import { CloseIcon as k } from "../../assets/svgs/CloseIcon.js";
import { HAS_WINDOW as v } from "../../constants/index.js";
/* empty css                  */const R = (w) => {
  const {
    isOpen: r,
    setIsOpen: C,
    children: L,
    className: N,
    title: d,
    titleAction: a,
    hasTitleArrow: x,
    Footer: m,
    hideHeader: b,
    PreContent: u
  } = w, t = s(null), n = s(null), l = s(null), f = () => C(!1);
  return p(() => {
    if (v)
      return r ? window.document.body.classList.add("no-scroll") : window.document.body.classList.remove("no-scroll"), () => {
        window.document.body.classList.remove("no-scroll");
      };
  }, [r]), p(() => {
    n.current && t.current && (t.current.style.maxHeight = `calc(100% - 56px - ${n.current.offsetHeight}px)`);
    const c = (e) => {
      var h;
      l.current && (e == null ? void 0 : e.target) instanceof Node && !((h = l.current) != null && h.contains(e == null ? void 0 : e.target)) && f();
    };
    return r ? document.addEventListener("mousedown", c) : document.removeEventListener("mousedown", c), () => {
      document.removeEventListener("mousedown", c);
    };
  }, [r]), r ? /* @__PURE__ */ o(
    "div",
    {
      id: "modal-container",
      "data-testid": "modal-container",
      className: N,
      children: /* @__PURE__ */ o("div", { id: "modal-content-container", children: /* @__PURE__ */ i("div", { id: "modal-content", ref: l, children: [
        !b && /* @__PURE__ */ i("header", { children: [
          a ? /* @__PURE__ */ i("button", { onClick: a, className: "modal-title", children: [
            x && /* @__PURE__ */ o(
              g,
              {
                rotate: "Left",
                color: "var(--color-support-links)"
              }
            ),
            d
          ] }) : /* @__PURE__ */ o("h2", { className: "modal-title", children: d }),
          /* @__PURE__ */ o("button", { onClick: f, className: "modal-close", children: /* @__PURE__ */ o(k, { color: "var(--color-main)" }) })
        ] }),
        !!u && u,
        /* @__PURE__ */ o("div", { ref: t, children: L }),
        m && /* @__PURE__ */ o("footer", { className: "modal-footer", ref: n, children: m })
      ] }) })
    }
  ) : null;
};
export {
  R as Modal
};
